import type { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import LineItemSummaryService from '@/Services/CampaignManagement/LineItemSummary.service';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import InfoTable, { rowspanTableMaxRows } from './InfoTable';

const GeoInfo = memo(() => {
  const { getValues } = useFormContext<ILineItemForm>();

  const { included, excluded, radius } = LineItemSummaryService.getGeoInfo(getValues());
  return (
    <>
      {radius?.length ? (
        <InfoTable caption='Radius Targeting' rows={radius} maxRows={rowspanTableMaxRows} />
      ) : included?.length ? (
        <InfoTable caption='Geo Inclusions' rows={included} maxRows={rowspanTableMaxRows} />
      ) : null}
      {excluded?.length ? <InfoTable caption='Geo Exclusions' rows={excluded} maxRows={rowspanTableMaxRows} /> : null}
    </>
  );
});

export default GeoInfo;
